'use client';

import React from 'react';

interface DatePickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  minDate?: string;
}

export default function DatePicker({ label, value, onChange, error, minDate }: DatePickerProps) {
  return (
    <div>
      <label className="block text-xs font-semibold text-muted-foreground mb-1.5 tracking-wide uppercase">
        {label}
      </label>
      <div className={`flex items-center border rounded-xl bg-input transition-all duration-150 ${error ? 'border-red-400' : 'border-border'}`}>
        <svg className="w-4 h-4 text-muted-foreground ml-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <input
          type="date"
          value={value}
          min={minDate}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 bg-transparent px-3 py-3 text-sm font-medium text-foreground outline-none cursor-pointer focus:ring-0"
          style={{ colorScheme: 'light' }}
        />
      </div>
      {error && <p className="mt-1 text-xs text-red-500 font-medium">{error}</p>}
    </div>
  );
}